import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal }                               from '@ng-bootstrap/ng-bootstrap';

import { CompanyListsService } from './company-lists.service';
import { CompanyService }      from '../companies/company.service';
import { MessagesService }     from '../messages/messages.service';
import { TemplateModel }       from '../templates/typings/template';

@Component({
  selector   : 'wor-company-lists-template',
  template: require('./company-lists.template.component.html')
})
export class CompanyListsTemplateComponent implements OnInit {
  @Input() template: TemplateModel;

  regoLabel: string = this.companyService.getLabels().rego;

  smsCharacterCount = 160;

  constructor (
    public  activeModal         : NgbActiveModal,
    @Inject(forwardRef(() => CompanyListsService))
    private companyListsService : CompanyListsService,
    private companyService      : CompanyService,
    private messagesService     : MessagesService
  ) {}

  ngOnInit () : void {
    if ( this.template.wording_type === 'sms' ) {
      this.filterHtml();
    }
  }

  filterHtml () : void {
    this.template.wording = this.template.wording
      ? String(this.template.wording).replace(/<[^>]+>/gm, '')
      : '';
  }

  save () : void {
    this.companyListsService.saveTemplate(this.template)
    .then(template => this.activeModal.close(template))
    .catch(error => this.messagesService.error(error));
  }
}
